import React from 'react';
import { FadeIn } from './FadeIn';
import { Thermometer, Activity } from 'lucide-react';
export function TheProblem() {
  return <section className="py-16 md:py-24 px-4" data-id="element-154">
      <div className="max-w-4xl mx-auto" data-id="element-155">
        <FadeIn data-id="element-156">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-157">
            El problema no es que hayas olvidado cómo dormir
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-158">
          <FadeIn delay={0.1} data-id="element-159">
            <div className="bg-navy-800/50 p-8 rounded-2xl border border-navy-700 h-full" data-id="element-160">
              <Thermometer className="w-12 h-12 text-amber-500 mb-6" data-id="element-161" />
              <h3 className="text-xl font-bold mb-4 text-white" data-id="element-162">
                Desajuste Biológico
              </h3>
              <p className="text-lavender-200" data-id="element-163">
                El problema es que después de los 50, tu "termostato" interno y
                tu ciclo de cortisol se han desincronizado. Es un desajuste
                biológico que las pastillas no pueden arreglar y que el café de
                la tarde solo empeora.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-164">
            <div className="bg-navy-800/50 p-8 rounded-2xl border border-navy-700 h-full" data-id="element-165">
              <Activity className="w-12 h-12 text-amber-500 mb-6" data-id="element-166" />
              <h3 className="text-xl font-bold mb-4 text-white" data-id="element-167">
                Cuerpo vs Mente
              </h3>
              <p className="text-lavender-200" data-id="element-168">
                Estás intentando dormir con un cuerpo que biológicamente cree
                que es mediodía. Por eso, aunque estés agotado físicamente, tu
                mente se siente "eléctrica" al tocar la almohada.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}